import React from 'react';
import DocumentAnalyzer from '../components/contract/DocumentAnalyzer';
import { useNavigate } from 'react-router-dom';

const RecentActivityPage = () => {
  // Render only the history view of DocumentAnalyzer
  return (
    <div className="h-full">
      <DocumentAnalyzer initialView="history" />
    </div>
  );
};

export default RecentActivityPage; 